import React from 'react';
import Button from '../../../components/Button';
import Checkbox from '../../../components/Checkbox';
import InputField from '../../../components/InputField';
import InputSelect from '../../../components/InputSelect';
import TextArea from '../../../components/TextArea';
import Typography from '../../../components/Typography';
import { SurveyInputData } from '../../../models/Survey';

type Props = {
    data: SurveyInputData;
    handleSubmit: (data: SurveyInputData) => void;
};

const SurveyInputDetail: React.FC<Props> = ({ data, handleSubmit }) => {
    const [detail, setDetail] = React.useState(data);

    React.useEffect(() => {
        setDetail(data);
    }, [data]);

    const handleChange = (name: string, value: string | boolean | number) => {
        setDetail({ ...detail, [name]: value });
    };

    const inputTypeOptions = [
        { label: 'text', value: 'text' },
        { label: 'number', value: 'number' },
        { label: 'date', value: 'date' },
    ];

    return (
        <div className="detail">
            <Typography variant="subtitle" color="primary">
                INPUT FIELD DETAILS
            </Typography>
            <hr />
            <Typography variant="body">Please provide title for the form field.</Typography>
            <InputField onChange={handleChange} name="title" value={detail.title} />
            <Typography variant="body">Please provide description if applicable.</Typography>
            <TextArea onChange={handleChange} name="description" value={detail.description} />
            <Typography variant="body">Select input type</Typography>
            <InputSelect options={inputTypeOptions} name="type" placeholder="select type" onChange={handleChange} />
            <Checkbox
                onChange={() => handleChange('required', !detail.required)}
                label={'This is a required field'}
                checked={detail.required ? detail.required : false}
            />
            <div className="action-container">
                <Button onClick={() => handleSubmit(detail)}>Update Item</Button>
            </div>
        </div>
    );
};

export default SurveyInputDetail;
